import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import AiCreditsMessagesIcon from '~/assets/AiCreditsMessagesIcon';
import QuotasIcon from '~/assets/QuotasIcon';
import Button from '~/components/Button';
import Modal from '~/components/Modal';

import { BodyWrapper, FooterRow, IconTile, Row, RowBody, RowTitle, TextColumn } from './SessionLimitInfoModal.styles';

interface SessionLimitInfoModalProps {
  open: boolean;
  onClose: () => void;
}

const SessionLimitInfoModal = ({ open, onClose }: SessionLimitInfoModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose} title={t('aiInsights.usageModalTitle')} width="37.5rem" hideFooter>
      <BodyWrapper>
        <Row>
          <IconTile>
            <AiCreditsMessagesIcon />
          </IconTile>
          <TextColumn>
            <RowTitle>{t('aiInsights.usageModalCreditsTitle')}</RowTitle>
            <RowBody>
              <Trans i18nKey="aiInsights.usageModalCreditsBody" components={{ br: <br /> }} />
            </RowBody>
          </TextColumn>
        </Row>
        <Row>
          <IconTile>
            <QuotasIcon />
          </IconTile>
          <TextColumn>
            <RowTitle>{t('aiInsights.usageModalQuotasTitle')}</RowTitle>
            <RowBody>{t('aiInsights.usageModalQuotasBody')}</RowBody>
          </TextColumn>
        </Row>
        <FooterRow>
          <Button onClick={onClose}>{t('aiInsights.gotIt')}</Button>
        </FooterRow>
      </BodyWrapper>
    </Modal>
  );
};

export default SessionLimitInfoModal;
